<app-single-page />

<ng-template #template_details>
    <app-register-details
        (onEscape)="emit_onEscape();"
        (onPageLoaded)="emit_onPageLoaded()"
    />
</ng-template>
